import React from 'react';
import { Box, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import Meta from '@bizapp-lp/pjr/organisms/Meta';
import { Complete } from '@bizapp-lp/pjr/templates/Complete';
import { LinkCard } from '@bizapp-lp/pjr/molecules/LinkCard';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      marginBottom: theme.spacing(10),
      '& .MuiTypography-body1': {
        margin: '0 auto 5px',
      },
    },
    gridItems: {
      margin: theme.spacing(3, 1, 0),
    },
  }),
);

const title =
  'Project Room Zoom用ドキュメント | 社内外とのプロジェクトを複数同時に進める現場のコラボレーションを支援・促進します';
const description =
  'Project Roomは、プロジェクトのための、簡単・安全に利用できるコミュニケーションツール。社外関係者も含めたプロジェクトメンバー全体のコミュニケーションを活性化し、エンゲージメントを向上します。プロジェクトで取り扱うファイルや予定の共有も一か所に集約でき、情報共有やノウハウ蓄積、共同作業をサポートします。';

const DocumentForZoom: React.FC = React.memo(() => {
  const classes = useStyles();

  const downloadCards = [
    {
      imgSrc: ``,
      imgAlt: 'Project Room はじめてガイド',
      headingText: 'はじめてガイド',
      children: <></>,
      onClick: () =>
        window.open(
          'https://bizapp.worksap.co.jp/resource/pjr-zoom0001',
          '_blank',
        ),
    },
    {
      imgSrc: ``,
      imgAlt: 'Project Room 利用ガイド',
      headingText: '利用ガイド',
      children: <></>,
      onClick: () =>
        window.open(
          'https://bizapp.worksap.co.jp/resource/pjr-zoom0002',
          '_blank',
        ),
    },
    {
      imgSrc: ``,
      imgAlt: 'Project Room 管理機能操作マニュアル',
      headingText: '管理機能操作マニュアル',
      children: <></>,
      onClick: () =>
        window.open(
          'https://bizapp.worksap.co.jp/resource/pjr-zoom0003',
          '_blank',
        ),
    },
    {
      imgSrc: ``,
      imgAlt: 'Project Room 管理者向けFAQ',
      headingText: '管理者向けFAQ',
      children: <></>,
      onClick: () =>
        window.open(
          'https://bizapp.worksap.co.jp/resource/pjr-zoom0004',
          '_blank',
        ),
    },
    {
      imgSrc: ``,
      imgAlt: 'Project Room 管理者向けはじめてガイド',
      headingText: '管理者向けはじめてガイド',
      children: <></>,
      onClick: () =>
        window.open(
          'https://bizapp.worksap.co.jp/resource/pjr-zoom0005',
          '_blank',
        ),
    },
    {
      imgSrc: ``,
      imgAlt: 'Project Room_Zoom連携の手順',
      headingText: 'Zoom連携の手順',
      children: <></>,
      onClick: () =>
        window.open(
          'https://bizapp.worksap.co.jp/resource/pjr-zoom0006',
          '_blank',
        ),
    },
    {
      imgSrc: ``,
      imgAlt: 'Project Roomユーザー向けFAQ',
      headingText: 'ユーザー向けFAQ',
      children: <></>,
      onClick: () =>
        window.open(
          'https://bizapp.worksap.co.jp/resource/pjr-zoom0007',
          '_blank',
        ),
    },
  ];

  return (
    <>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <Complete
        heading1={'Room Zoom用ドキュメント'}
        heading2="Project Room Zoom用ドキュメントのまとめページ"
        description=""
      >
        <Box className={classes.gridContainer}>
          {downloadCards.map((props, i) => (
            <Box className={classes.gridItems}>
              <LinkCard iconVariant="download" {...props} key={i} />
            </Box>
          ))}
        </Box>
      </Complete>
    </>
  );
});

export default DocumentForZoom;
